package com.evoapps.evoshift.domain.usecase.daily

import com.evoapps.evoshift.domain.model.DailyRecord
import com.evoapps.evoshift.domain.repository.FinancialRepository

class GetDailyLogUseCase(
    private val financialRepository: FinancialRepository
) {
    suspend operator fun invoke(dailyRecordId: String): Result<DailyRecord> {
        return financialRepository.getDailyRecord(dailyRecordId)
    }
}